// extracted by mini-css-extract-plugin
export default {"duration":"duration__1L4Zp"};